// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_OTv","cls2":"DebugPage-cls2_vig DebugPage-cls1_OTv"};